import { render, staticRenderFns } from "./shellScheme.vue?vue&type=template&id=e25332a0&scoped=true"
import script from "./shellScheme.vue?vue&type=script&lang=js"
export * from "./shellScheme.vue?vue&type=script&lang=js"
import style0 from "./shellScheme.vue?vue&type=style&index=0&id=e25332a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25332a0",
  null
  
)

export default component.exports